<template>
  <div :class="[style.block, style.offPaddingTop]">
    <InputStyle
      description="Заголовок"
      placeholder="Введите заголовок"
      size="M"
      textarea
      :modelValue="questionTitle"
      @update:modelValue="setQuestionTitle"
    />
  </div>

  <div :class="style.block">
    <InputStyle
      description="Описание"
      placeholder="Введите описание"
      size="M"
      textarea
      :modelValue="questionDescription"
      @update:modelValue="setQuestionDescription"
    />
  </div>

  <div :class="style.block" v-if="mobileVersion">
    <InputStyle
      description="Текст под кнопкой"
      placeholder="Введите текст"
      size="M"
      :modelValue="textBellowButton"
      @update:modelValue="setTextBellowButton"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";

import style from "../../QuestionPanelComponent.module.scss";

import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";
import {questions} from "@/page/quiz/typeQuiz";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";

export default defineComponent({
  name: "DentalQuestionContent",

  components: {
    InputStyle
  },

  props: {
    question: {
      type: Object as PropType<questions | null>,
      default: null
    },

    questionIndex: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    questionTitle(): string {
      return this.question?.question || "";
    },

    questionDescription(): string {
      return this.question?.contacts?.paragraph || "";
    },

    textBellowButton(): string {
      return modifyQuiz("get", "", ["textBellowButton"]) ?? "";
    },

    mobileVersion(): boolean {
      return this.selectedVersion === "Мобильная";
    },

    selectedVersion(): string {
      return this.$quizStore.getSelectedVersion;
    }
  },

  methods: {
    setQuestionTitle(value: string): void {
      if (!this.question) {
        return;
      }

      this.question.question = value;
    },

    setQuestionDescription(value: string): void {
      if (!this.question) {
        return;
      }

      this.ensureContacts();

      this.question.contacts!.paragraph = value;
    },

    setTextBellowButton(value: string): void {
      if (!this.question) {
        return;
      }

      modifyQuiz("set", value, ["textBellowButton"]);
    },

    ensureContacts(): void {
      if (!this.question) {
        return;
      }

      if (!this.question.contacts) {
        this.question.contacts = {};
      }
    }
  }
});
</script>
